/**
 * Market Data API
 * Re-exports appApi for market data
 */

import { appApi } from '@/infrastructure/api';

export { appApi };
export default appApi;

